export const moveElementTo = (
  elementSelector,
  targetSelector,
  position = "beforeend"
) => {
  let element = elementSelector;
  let target = targetSelector;
  // console.log(element);
  // console.log(target);

  if (typeof elementSelector === "string") {
    element = document.querySelector(elementSelector);
  }
  // console.log(element);

  if (typeof targetSelector === "string") {
    target = document.querySelector(targetSelector);
  }
  // console.log(target);

  target.insertAdjacentHTML(position, element.outerHTML);
  element.remove();
};
